import { ValueOf } from '@/types/value-of.type'

export const DATA_GROUP = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  QUARTER: 'quarter',
  AGGREGATION: 'aggregation',
}
export type DATA_GROUP = ValueOf<typeof DATA_GROUP>